import React, { useState, useEffect } from "react";
import {
    Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Collapse,
  useMediaQuery
} from "@mui/material";
//import useStyles  from "../theme/formCssStyles";

import { Link, useHistory, useLocation, useRouteMatch } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { makeStyles } from "@mui/styles";
import { useTheme } from "@mui/material/styles";
import { useAuth } from "../context/authContext";

const useStyles1 = makeStyles((theme) => ({
  drawerLink:{
    textDecoration:"none",
    color: "blue",
    fontSize: "14px",
    fontWeight: "500",
    "&:hover, &:focus, &:active, &.Mui-focusVisible": {
      backgroundColor: "transparent"
    }
},
  drawerLinkActive:{
    textDecoration:"none",
    color: "#fff",
    fontSize: "14px",
    fontWeight: "700",
    backgroundColor: "#0047AB",
    display: "block",
    padding: "8px 16px",
    borderRadius: "4px",
    boxShadow: "0 4px 12px rgba(0, 71, 171, 0.6), inset 0 1px 0 rgba(255,255,255,0.2)",
    border: "2px solid #FFD700",
    letterSpacing: "0.5px",
    "&:hover, &:focus, &:active, &.Mui-focusVisible": {
      backgroundColor: "#0047AB"
    }
},
icon:{
    color: "white",
    position: "fixed",
    top: 12,
    left: 12,
    zIndex: 1302,
    backgroundColor: "rgba(0,0,0,0.3)",
    borderRadius: "4px",
    padding: "8px",
    "&:hover": {
      backgroundColor: "rgba(0,0,0,0.5)"
    },
    [theme.breakpoints.up("md")]: {
      display: "none"
    }
},
  drawer: {
    width: 232,
    zIndex:1000
  },
  // Styles for the `Paper` component rendered by `Drawer`.
  drawerPaper: {
    width: "inherit",
    paddingTop: 64, // equal to AppBar height
    zIndex: 1000,
    [theme.breakpoints.down("sm")]: {
      width: "80vw",
      maxWidth: 300,
      paddingTop: 56, // Smaller padding for mobile AppBar
      boxShadow: "2px 0 8px rgba(0,0,0,0.15)"
    }
  },
  listText: {
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
      padding: "12px 16px"
    }
  },
  listItem: {
    [theme.breakpoints.down("sm")]: {
      minHeight: 48, // Better touch targets
      padding: "8px 16px"
    }
  }
}));
function DrawerComponent(props)
{
    const classes = useStyles1();
    const [openDrawer, setOpenDrawer] = useState(false);
    const history = useHistory();
    const location = useLocation();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const { user, clearSelectedClub } = useAuth();
    const userRoleRaw = user?.role ?? user?.userType ?? user?.type ?? user?.role_id ?? user?.roleId;
    const userRole = Number(userRoleRaw);
    const isClubSelectionScreen = location.pathname && location.pathname.toLowerCase().includes('/clubmanagement');
    // For the superadmin, "in a club" is now driven by the URL (/club/:issuerId),
    // so the menu follows browser Back/Forward and can never desync. Other roles
    // use their fixed login-assigned club.
    const routeMatch = useRouteMatch('/club/:issuerId');
    const issuerIdFromUrl = (routeMatch && routeMatch.params) ? routeMatch.params.issuerId : null;
    // Superadmin's club id comes from the URL (the club they selected); the club
    // roles use their fixed login-assigned club (user.issuerId).
    const menuClubId = issuerIdFromUrl || (userRole !== 100 ? user?.issuerId : null);
    const clubPath = (slug) => `/club/${menuClubId}/${slug}`;
    const hasSelectedClub = userRole === 100
        ? Boolean(routeMatch)
        : Boolean(user?.issuerId);

    // Collapsible submenu groups (superadmin menu): "Issue Membership Pass" and
    // "Issue Coupon". Each parent toggles open; a parent auto-expands when its
    // child page is the active route (e.g. on refresh / deep link).
    const isMembershipSectionActive = location.pathname === clubPath('single-pass') || location.pathname === clubPath('bulk-passes');
    const isReissueSectionActive = location.pathname === clubPath('reissue-passes') || location.pathname === clubPath('reissue-single-pass');
    // Coupons are two groups, split by promotion type: membership coupons are
    // Member offers (2), consumer coupon passes are Public promotions (1).
    const isMembershipCouponSectionActive = location.pathname === clubPath('membership-coupon-single') || location.pathname === clubPath('membership-coupon-multiple');
    const isConsumerCouponSectionActive = location.pathname === clubPath('consumer-coupon-single') || location.pathname === clubPath('consumer-coupon-multiple');
    const [openMembership, setOpenMembership] = useState(false);
    const [openReissue, setOpenReissue] = useState(false);
    const [openMembershipCoupon, setOpenMembershipCoupon] = useState(false);
    const [openConsumerCoupon, setOpenConsumerCoupon] = useState(false);
    const [openReports, setOpenReports] = useState(false);
    // Every is*SectionActive belongs in these deps — omit one and that parent
    // silently stops auto-expanding on a deep link.
    useEffect(() => {
      if (isMembershipSectionActive) setOpenMembership(true);
      if (isReissueSectionActive) setOpenReissue(true);
      if (isMembershipCouponSectionActive) setOpenMembershipCoupon(true);
      if (isConsumerCouponSectionActive) setOpenConsumerCoupon(true);
    }, [isMembershipSectionActive, isReissueSectionActive, isMembershipCouponSectionActive, isConsumerCouponSectionActive]);

    function handleMenuItemClick() {
      if (isMobile) {
        setOpenDrawer(false);
      }
    }

    function handleDrawerClose() {
      setOpenDrawer(false);
    }

    function handleBackToFirstScreen() {
      clearSelectedClub();
      if (isMobile) {
        setOpenDrawer(false);
      }
      history.push('/ClubManagement');
    }

    // "Re-Issue Membership Pass(es)" group. Unlike the other collapsible groups this one is
    // available to EVERY club role, so it is defined once here and rendered
    // inside each role's block rather than copied four times. Access is still
    // enforced by PAGE_ROLES in ClubScope.js — this only draws the menu.
    const reissueMenuGroup = (
      <>
        <ListItem button onClick={() => setOpenReissue(!openReissue)} className={`${classes.drawerLink} ${classes.listItem}`} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <ListItemText disableTypography>
            <span className={classes.listText}>Re-Issue Membership Pass(es)</span>
          </ListItemText>
          {openReissue ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={openReissue} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItem button component={Link} to={clubPath('reissue-single-pass')} onClick={handleMenuItemClick} style={{ paddingLeft: 32 }} className={`${location.pathname === clubPath('reissue-single-pass') ? classes.drawerLinkActive : classes.drawerLink} ${classes.listItem}`}>
              <ListItemText disableTypography>
                <span className={classes.listText}>Single Pass</span>
              </ListItemText>
            </ListItem>
            <ListItem button component={Link} to={clubPath('reissue-passes')} onClick={handleMenuItemClick} style={{ paddingLeft: 32 }} className={`${location.pathname === clubPath('reissue-passes') ? classes.drawerLinkActive : classes.drawerLink} ${classes.listItem}`}>
              <ListItemText disableTypography>
                <span className={classes.listText}>Multiple Passes</span>
              </ListItemText>
            </ListItem>
          </List>
        </Collapse>
      </>
    );

    // Coupon issuing is TWO groups, split by promotion type — membership coupons
    // are Member offers (2), consumer coupon passes are Public promotions (1).
    // Both are shared by superadmin (100), Club Admin (110) and Club Manager
    // (101), so — like reissueMenuGroup above — each is defined once here and
    // rendered in those blocks rather than copied three times. Receptionist (102)
    // gets neither. Access is enforced by PAGE_ROLES in ClubScope.js; this only
    // draws the menu.
    const membershipCouponMenuGroup = (
      <>
        <ListItem button onClick={() => setOpenMembershipCoupon(!openMembershipCoupon)} className={`${classes.drawerLink} ${classes.listItem}`} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <ListItemText disableTypography>
            <span className={classes.listText}>Issue Membership Coupon(s)</span>
          </ListItemText>
          {openMembershipCoupon ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={openMembershipCoupon} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItem button component={Link} to={clubPath('membership-coupon-single')} onClick={handleMenuItemClick} style={{ paddingLeft: 32 }} className={`${location.pathname === clubPath('membership-coupon-single') ? classes.drawerLinkActive : classes.drawerLink} ${classes.listItem}`}>
              <ListItemText disableTypography>
                <span className={classes.listText}>Single Member</span>
              </ListItemText>
            </ListItem>
            <ListItem button component={Link} to={clubPath('membership-coupon-multiple')} onClick={handleMenuItemClick} style={{ paddingLeft: 32 }} className={`${location.pathname === clubPath('membership-coupon-multiple') ? classes.drawerLinkActive : classes.drawerLink} ${classes.listItem}`}>
              <ListItemText disableTypography>
                <span className={classes.listText}>Multiple Members</span>
              </ListItemText>
            </ListItem>
          </List>
        </Collapse>
      </>
    );

    const consumerCouponMenuGroup = (
      <>
        <ListItem button onClick={() => setOpenConsumerCoupon(!openConsumerCoupon)} className={`${classes.drawerLink} ${classes.listItem}`} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <ListItemText disableTypography>
            <span className={classes.listText}>Issue Consumer Coupon Pass(es)</span>
          </ListItemText>
          {openConsumerCoupon ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={openConsumerCoupon} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItem button component={Link} to={clubPath('consumer-coupon-single')} onClick={handleMenuItemClick} style={{ paddingLeft: 32 }} className={`${location.pathname === clubPath('consumer-coupon-single') ? classes.drawerLinkActive : classes.drawerLink} ${classes.listItem}`}>
              <ListItemText disableTypography>
                <span className={classes.listText}>Single Consumer</span>
              </ListItemText>
            </ListItem>
            <ListItem button component={Link} to={clubPath('consumer-coupon-multiple')} onClick={handleMenuItemClick} style={{ paddingLeft: 32 }} className={`${location.pathname === clubPath('consumer-coupon-multiple') ? classes.drawerLinkActive : classes.drawerLink} ${classes.listItem}`}>
              <ListItemText disableTypography>
                <span className={classes.listText}>Multiple Consumer</span>
              </ListItemText>
            </ListItem>
          </List>
        </Collapse>
      </>
    );

    const redemptionReportsMenuItem = (
      <ListItem button component={Link} to={clubPath('redemption-reports')} onClick={handleMenuItemClick} className={`${location.pathname === clubPath('redemption-reports') ? classes.drawerLinkActive : classes.drawerLink} ${classes.listItem}`}>
        <ListItemText disableTypography>
          <span className={classes.listText}>Redemption Reports</span>
        </ListItemText>
      </ListItem>
    );


    // const drawer = (
    //     <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
    //       {/* <Typography variant="h6" sx={{ my: 2 }}>
    //         MUI
    //       </Typography> */}
    //       <Divider />
    //       <List>
    //         {props.navItems.map((item) => (
    //                 <ListItem>
    //                     <ListItemText>
                            
    //                         <Link to={"/"+item} >
    //                             item
    //                         </Link>
    //                     </ListItemText>    
    //                 </ListItem>
    //             ))}
    //       </List>
    //     </Box>
    //   );
    
    return (
          <>
            <Drawer
              className={classes.drawer}
              classes={{ paper: classes.drawerPaper }}
              variant={isMobile ? "temporary" : "permanent"}
              open={isMobile ? openDrawer : true}
              onClose={handleDrawerClose}
              ModalProps={{
                keepMounted: true, // Better open performance on mobile
              }}
            >
              <div>
              <List>
                  {(userRole === 100 && !hasSelectedClub) && (
                    <ListItem button component={Link} to="/ClubManagement" onClick={handleMenuItemClick} className={`${location.pathname === '/ClubManagement' ? classes.drawerLinkActive : classes.drawerLink} ${classes.listItem}`}>
                      <ListItemText disableTypography>
                        <span className={classes.listText}>Club management</span>
                      </ListItemText>
                    </ListItem>
                  )}

                  {(userRole === 100 && !hasSelectedClub) && (
                    <ListItem button component={Link} to="/SummaryReport" onClick={handleMenuItemClick} className={`${location.pathname === '/SummaryReport' ? classes.drawerLinkActive : classes.drawerLink} ${classes.listItem}`}>
                      <ListItemText disableTypography>
                        <span className={classes.listText}>Summary Report</span>
                      </ListItemText>
                    </ListItem>
                  )}

                  {(userRole === 100 && !hasSelectedClub) && (
                    <ListItem button component={Link} to="/GeneralReport" onClick={handleMenuItemClick} className={`${location.pathname === '/GeneralReport' ? classes.drawerLinkActive : classes.drawerLink} ${classes.listItem}`}>
                      <ListItemText disableTypography>
                        <span className={classes.listText}>General Report</span>
                      </ListItemText>
                    </ListItem>
                  )}

                  {(userRole === 100 && !hasSelectedClub) && (
                  <Divider style={{ borderTop: '4px double #0047AB', margin: '2px 0' }} />)}
                  {(userRole === 100 && hasSelectedClub) && (
                    <ListItem button component={Link} to={clubPath('promotions')} onClick={handleMenuItemClick} className={`${location.pathname === clubPath('promotions') ? classes.drawerLinkActive : classes.drawerLink} ${classes.listItem}`}>
                      <ListItemText disableTypography>
                        <span className={classes.listText}>Promotions</span>
                      </ListItemText>
                    </ListItem>
                  )}
                  {(userRole === 100 && hasSelectedClub) && (
                    <ListItem button component={Link} to={clubPath('redemption-partner')} onClick={handleMenuItemClick} className={`${location.pathname === clubPath('redemption-partner') ? classes.drawerLinkActive : classes.drawerLink} ${classes.listItem}`}>
                      <ListItemText disableTypography>
                        <span className={classes.listText}>Redemption Partner</span>
                      </ListItemText>
                    </ListItem>
                  )}
                  {(userRole === 100 && hasSelectedClub) && (
                    <ListItem button component={Link} to={clubPath('s7000')} onClick={handleMenuItemClick} className={`${location.pathname === clubPath('s7000') ? classes.drawerLinkActive : classes.drawerLink} ${classes.listItem}`}>
                      <ListItemText disableTypography>
                        <span className={classes.listText}>S7000 Configuration</span>
                      </ListItemText>
                    </ListItem>
                  )}
                  {(userRole === 100 && hasSelectedClub) && (
                    <ListItem button component={Link} to={clubPath('users')} onClick={handleMenuItemClick} className={`${location.pathname === clubPath('users') ? classes.drawerLinkActive : classes.drawerLink} ${classes.listItem}`}>
                      <ListItemText disableTypography>
                        <span className={classes.listText}>User Management</span>
                      </ListItemText>
                    </ListItem>
                  )}
                  {(userRole === 100 && hasSelectedClub) && (
                    <>
                      <Divider style={{ borderTop: '4px double #0047AB', margin: '2px 0' }} />
                      <ListItem button component={Link} to={clubPath('locations')} onClick={handleMenuItemClick} className={`${location.pathname === clubPath('locations') ? classes.drawerLinkActive : classes.drawerLink} ${classes.listItem}`}>
                        <ListItemText disableTypography>
                          <span className={classes.listText}>Manage Locations</span>
                        </ListItemText>
                      </ListItem>
                      <Divider />
                      <ListItem button component={Link} to={clubPath('promotion-location')} onClick={handleMenuItemClick} className={`${location.pathname === clubPath('promotion-location') ? classes.drawerLinkActive : classes.drawerLink} ${classes.listItem}`}>
                        <ListItemText disableTypography>
                          <span className={classes.listText}>Link Promotion And Location</span>
                        </ListItemText>
                      </ListItem>
                      <Divider style={{ borderTop: '4px double #0047AB', margin: '2px 0' }} />
                      {/* Issue Membership Pass (parent) -> Single Pass / Multiple Passes */}
                      <ListItem button onClick={() => setOpenMembership(!openMembership)} className={`${classes.drawerLink} ${classes.listItem}`} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <ListItemText disableTypography>
                          <span className={classes.listText}>Issue Membership Pass(es)</span>
                        </ListItemText>
                        {openMembership ? <ExpandLess /> : <ExpandMore />}
                      </ListItem>
                      <Collapse in={openMembership} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                          <ListItem button component={Link} to={clubPath('single-pass')} onClick={handleMenuItemClick} style={{ paddingLeft: 32 }} className={`${location.pathname === clubPath('single-pass') ? classes.drawerLinkActive : classes.drawerLink} ${classes.listItem}`}>
                            <ListItemText disableTypography>
                              <span className={classes.listText}>Single Pass</span>
                            </ListItemText>
                          </ListItem>
                          <ListItem button component={Link} to={clubPath('bulk-passes')} onClick={handleMenuItemClick} style={{ paddingLeft: 32 }} className={`${location.pathname === clubPath('bulk-passes') ? classes.drawerLinkActive : classes.drawerLink} ${classes.listItem}`}>
                            <ListItemText disableTypography>
                              <span className={classes.listText}>Multiple Passes</span>
                            </ListItemText>
                          </ListItem>
                        </List>
                      </Collapse>
                      <Divider />
                      {reissueMenuGroup}
                      <Divider />
                      {membershipCouponMenuGroup}
                      <Divider />
                      {consumerCouponMenuGroup}
                      <Divider style={{ borderTop: '4px double #0047AB', margin: '2px 0' }} />
                      <ListItem button onClick={() => setOpenReports(!openReports)} className={`${classes.drawerLink} ${classes.listItem}`} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <ListItemText disableTypography>
                          <span className={classes.listText}>Reports</span>
                        </ListItemText>
                        {openReports ? <ExpandLess /> : <ExpandMore />}
                      </ListItem>
                      <Collapse in={openReports} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                          {redemptionReportsMenuItem}
                        </List>
                      </Collapse>
                      <Divider />
                      <ListItem button component="a" href="https://litecard.io/" target="_blank" rel="noopener noreferrer" onClick={handleMenuItemClick} className={`${classes.drawerLink} ${classes.listItem}`}>
                        <ListItemText disableTypography>
                          <span className={classes.listText}>Manage Wallet Passes</span>
                        </ListItemText>
                      </ListItem>
                    </>
                  )}
                  {/* Club Admin (110) */}
                  {(userRole === 110) && (
                    <>
                      <ListItem button component={Link} to={clubPath('promotions')} onClick={handleMenuItemClick} className={`${location.pathname === clubPath('promotions') ? classes.drawerLinkActive : classes.drawerLink} ${classes.listItem}`}>
                        <ListItemText disableTypography><span className={classes.listText}>Promotions</span></ListItemText>
                      </ListItem>
                      <Divider style={{ borderTop: '4px double #0047AB', margin: '2px 0' }} />
                      <ListItem button component={Link} to={clubPath('locations')} onClick={handleMenuItemClick} className={`${location.pathname === clubPath('locations') ? classes.drawerLinkActive : classes.drawerLink} ${classes.listItem}`}>
                        <ListItemText disableTypography><span className={classes.listText}>Manage Locations</span></ListItemText>
                      </ListItem>
                      <Divider />
                      <ListItem button component={Link} to={clubPath('promotion-location')} onClick={handleMenuItemClick} className={`${location.pathname === clubPath('promotion-location') ? classes.drawerLinkActive : classes.drawerLink} ${classes.listItem}`}>
                        <ListItemText disableTypography><span className={classes.listText}>Link Promotion And Location</span></ListItemText>
                      </ListItem>
                      <Divider style={{ borderTop: '4px double #0047AB', margin: '2px 0' }} />
                      <ListItem button component={Link} to={clubPath('single-pass')} onClick={handleMenuItemClick} className={`${location.pathname === clubPath('single-pass') ? classes.drawerLinkActive : classes.drawerLink} ${classes.listItem}`}>
                        <ListItemText disableTypography><span className={classes.listText}>Single Membership Pass</span></ListItemText>
                      </ListItem>
                      <Divider />
                      {reissueMenuGroup}
                      <Divider />
                      {membershipCouponMenuGroup}
                      <Divider />
                      {consumerCouponMenuGroup}
                        {redemptionReportsMenuItem}
                      <Divider style={{ borderTop: '4px double #0047AB', margin: '2px 0' }} />
                    </>
                  )}
                  {/* Club Manager (101) */}
                  {(userRole === 101) && (
                    <>
                      <ListItem button component={Link} to={clubPath('promotions')} onClick={handleMenuItemClick} className={`${location.pathname === clubPath('promotions') ? classes.drawerLinkActive : classes.drawerLink} ${classes.listItem}`}>
                        <ListItemText disableTypography><span className={classes.listText}>Promotions</span></ListItemText>
                      </ListItem>
                      <Divider />
                      {membershipCouponMenuGroup}
                      <Divider />
                      {consumerCouponMenuGroup}
                      <Divider />
                      {reissueMenuGroup}
                      <Divider />
                      {redemptionReportsMenuItem}
                    </>
                  )}
                  {/* Club Receptionist (102) */}
                  {(userRole === 102) && (
                    <>
                      <ListItem button component={Link} to={clubPath('single-pass')} onClick={handleMenuItemClick} className={`${location.pathname === clubPath('single-pass') ? classes.drawerLinkActive : classes.drawerLink} ${classes.listItem}`}>
                        <ListItemText disableTypography><span className={classes.listText}>Single Membership Pass</span></ListItemText>
                      </ListItem>
                      <Divider />
                      {reissueMenuGroup}
                    </>
                  )}
                  {(userRole === 100 && hasSelectedClub) && (
                    <>
                      <Divider style={{ borderTop: '4px double #0047AB', margin: '2px 0' }} />
                      <ListItem button onClick={handleBackToFirstScreen} className={`${classes.drawerLink} ${classes.listItem}`}>
                        <ListItemText disableTypography>
                          <span className={classes.listText}>Back</span>
                        </ListItemText>
                      </ListItem>
                    </>
                  )}
              </List>
              </div>
            </Drawer>
            <IconButton onClick={() => setOpenDrawer(!openDrawer)} className={classes.icon}>
              <MenuIcon />
            </IconButton>
          </>
        )};
    

export default DrawerComponent;
